import axios from 'axios';

const API_BASE_URL = 'https://2088.xn--p1ai/api';
const TOKEN_KEY = 'videochat_token';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Обрабатываем ответы
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Если ошибка 401 и это не попытка обновить токен
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
          throw new Error('No refresh token');
        }
        
        // Попытка обновить токен
        const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
          refreshToken: refreshToken
        });
        
        if (response.data.accessToken) {
          localStorage.setItem(TOKEN_KEY, response.data.accessToken);
          localStorage.setItem('refresh_token', response.data.refreshToken);
          
          originalRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.log("refreshError")
        
        // Если не удалось обновить - выходим из системы
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem('refresh_token');
        window.location.reload();

        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export const authService = {
  async register(userData) {
    const response = await api.post('/auth/register', {
      username: userData.username,
      email: userData.email,
      password: userData.password,
      confirmPassword: userData.confirmPassword,
      firstName: userData.firstName,
      lastName: userData.lastName
    });
    
    if (response.data.accessToken) {
      localStorage.setItem(TOKEN_KEY, response.data.accessToken);
      localStorage.setItem('refresh_token', response.data.refreshToken);
    }
    return response.data;
  },

  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    
    if (response.data.accessToken) {
      localStorage.setItem(TOKEN_KEY, response.data.accessToken);
      localStorage.setItem('refresh_token', response.data.refreshToken);
    }
    return response.data;
  },

  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async getAllUsers() {
    const response = await api.get('/auth/users');
    return response.data;
  },

  async logout(refreshToken) {
    console.log("logout")
    const response = await api.post('/auth/logout', { refreshToken });
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('lastSiteId');
    localStorage.removeItem('lastChannelId');
    return response.data;
  },

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  }

};